import { Component, OnInit, Input, SimpleChanges, ViewChild } from '@angular/core';
import { GlobalVariableService } from "../../../../common/variables/global-variable";
import { GlobalFunctionService } from "../../../../common/services/global-function.service";
import { TranslateService } from "../../../../common/variables/translate-service";
import { MatSort, Sort } from "@angular/material/sort";
import { MatTableDataSource } from '@angular/material/table';
import { ItemListGetComponentItem, ItemListGetItems } from "../../../../common/api/ItemListGet";

@Component({
  selector: 'sen-app-items-quantity',
  templateUrl: './items-quantity.component.html',
  styleUrls: ['./items-quantity.component.scss']
})

export class ItemsQuantityComponent implements OnInit {

  @ViewChild(MatSort) sort: MatSort;
  @Input() tableData: ItemListGetComponentItem;
  dataSource = new MatTableDataSource();
  displayedColumns: string[] = ['senItemID', 'imageURL', 'name', 'quantity', 'unit'];

  constructor(public global: GlobalVariableService, public globalF: GlobalFunctionService, public translate: TranslateService) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.tableData && changes.tableData.currentValue) {
      this.dataSource = new MatTableDataSource(this.tableData.items);
      // Sort by senItemID ascending initially
      this.sortData({
        active: 'senItemID',
        direction: 'asc'
      });
    }
  }

  ngOnInit(): void {
  }

  sortData(sort: Sort) {
    const data = this.dataSource.data;
    if (!sort.active || sort.direction === '') {
      // this.sortedData = data;
      return;
    }
    this.dataSource.data = data.sort((a: ItemListGetItems, b: ItemListGetItems) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'senItemID': return compare(a.senItemID, b.senItemID, isAsc);
        case 'name': return compare(a.name, b.name, isAsc);
        case 'quantity': return compare(a.quantity, b.quantity, isAsc);
        case 'unit': return compare(a.unit, b.unit, isAsc);
        default: return 0;
      }
    });
  }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
